import { notification } from 'antd'
import { ArgsProps } from 'antd/lib/notification'

import PerIcon from '../Icon'
import PerButtonCircle from '../ButtonCircle'
import './index.less'

const CONTENT_CONTAINER = '#content-container'
const CONTAINER_OFFSET = 24

type NotificationType = 'success' | 'warning' | 'error'
type NotificationProps = { type: NotificationType } & Pick<ArgsProps, 'message' | 'description'>

export const showNotification = (props: NotificationProps): void => {
  const container = document.querySelector(CONTENT_CONTAINER)

  const icon = props.type === 'success' ? 'check_stroke' : 'warning_fill'
  const color = props.type === 'success' ? 'success' : props.type === 'warning' ? 'warning' : 'error'

  notification.open({
    icon: <PerButtonCircle className="per-notification-icon" icon={icon} color={color} variant="bold" />,
    closeIcon: <PerIcon name="close_stroke" color="white" size={20} />,
    message: <div className="per-notification-title">{props.message}</div>,
    description: <div className="per-notification-description">{props.description}</div>,
    placement: 'bottomLeft',
    className: 'per-notification',
    style: {
      left: !!container ? container.getBoundingClientRect().left - CONTAINER_OFFSET : undefined,
    },
    duration: color !== 'success' ? 10 : 3,
  })
}
